import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
	state: {
		sidebarStatus: false,
		interactionsSidebarStatus: false,
		menuSidebarStatus: false,
		sidebarMini: false,
		sidebarMenu: [
			{
				name: 'Panel de Control',
				routeName: 'Dashboard',
				icon: 'mdi-view-dashboard-outline',
				active: true
			},
			{
				name: 'Proyectos',
				routeName: 'Proyectos',
				icon: 'mdi-format-list-text',
				active: false,
				subMenu: [
					{
						name: 'Cerrados',
						routeName: 'ClosedProjects',
						icon: 'mdi-view-dashboard-outline',
						active: false
					}
				]
			},
			{
				name: 'Empresas',
				routeName: 'Companies',
				icon: 'mdi-domain',
				active: false
			},
			{
				name: 'Usuarios',
				routeName: 'Usuarios',
				icon: 'mdi-account-multiple-outline',
				active: false
			},
			{
				name: 'Tareas',
				routeName: 'Consultas',
				code: 'tasks',
				icon: 'mdi-clipboard-text-outline',
				active: false
			},
			{
				name: 'RDIs',
				routeName: 'Rdi',
				code: 'rdi',
				icon: 'mdi-file-document-multiple-outline',
				active: false
			},
			{
				name: 'Entregas',
				routeName: 'Entregas',
				code: 'entrega',
				icon: 'mdi-format-list-checks',
				active: false
			},
			{
				name: 'Adicionales',
				routeName: 'Adicionales',
				code: 'additional',
				icon: 'mdi-notebook-plus-outline',
				active: false
			},
			{
				name: 'Libros/Folios',
				routeName: 'CommunicationBooks',
				code: 'communication_books',
				icon: 'mdi-book-open-page-variant-outline',
				active: false
			},
			{
				name: 'Planimetría',
				routeName: 'Planimetria',
				code: 'planimetry',
				icon: 'mdi-floor-plan',
				active: false
			},
			{
				name: 'Programación',
				routeName: 'Planning',
				code: 'planning',
				icon: 'mdi-calendar-month-outline',
				active: true
			},
			{
				name: 'Gestión de Documentos',
				routeName: 'FileManager',
				code: 'documents',
				icon: 'mdi-file-search-outline',
				active: true,
				subMenu: [
					{
						name: 'Listado Documentos',
						routeName: 'DocumentsRevision',
						code: 'documents',
						icon: 'mdi-file-document-multiple-outline',
						active: false
					}
				]
			},
			{
				name: 'Reuniones/Minutas',
				routeName: 'Meetings',
				code: 'meetings',
				icon: 'mdi-calendar-outline',
				active: true
			},
			{
				name: 'Programa de Compras',
				icon: 'mdi-chart-line',
				active: false
			},
			{
				name: 'Sub Contratos',
				icon: 'mdi-clipboard-edit-outline',
				active: false
			},
			{
				name: 'Bodega',
				icon: 'mdi-package-variant-closed',
				active: false
			},
		]
	},
	mutations: {
		setSidebarStatus(state, status){
			state.sidebarStatus = status
		},
		setInteractionsSidebarStatus(state, status){
			state.interactionsSidebarStatus = status
		},
		setMenuSidebarStatus(state, status){
			state.menuSidebarStatus = status
		},
		toggleSidebarMini(state){
			state.sidebarMini = !state.sidebarMini
		}
	}
})

export default store